// Wire message type constants. Payload shapes are documented in the plan file.
export const MSG = {
  // client → server
  JOIN: 'join',
  SET_READY: 'set_ready',
  INPUT: 'input',
  PING: 'ping',
  LEAVE_ROOM: 'leave_room',
  CAST_VOTE: 'cast_vote',
  RETURN_LOBBY: 'return_lobby',
  LIST_ROOMS: 'list_rooms',
  RING_BELL: 'ring_bell',

  // server → client
  WELCOME: 'welcome',
  ROOMS_LIST: 'rooms_list',
  LOBBY_STATE: 'lobby_state',
  GAME_START: 'game_start',
  SNAPSHOT: 'snapshot',
  SPAWN_ASTEROID: 'spawn_asteroid',
  DESTROY_ASTEROID: 'destroy_asteroid',
  SPAWN_BULLET: 'spawn_bullet',
  DESTROY_BULLET: 'destroy_bullet',
  SHIP_HIT: 'ship_hit',
  SHIP_SHIELDED: 'ship_shielded',
  SHIP_RESPAWN: 'ship_respawn',
  SCORE_UPDATE: 'score_update',
  HUD_FEED: 'hud_feed',
  GAME_OVER: 'game_over',
  PONG: 'pong',
  KICKED: 'kicked',
  ERROR: 'error',
  LOBBY_BELL: 'lobby_bell'
};

export const LOBBY_STATUS = {
  WAITING: 'waiting',
  READY: 'ready'
};

export const ROOM_STATE = {
  WAITING: 'WAITING',
  PLAYING: 'PLAYING',
  ENDED: 'ENDED'
};
